import React, {Component} from 'react';
import '../App.css';
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import {Helmet} from "react-helmet";

class Navbar extends Component  {
  constructor() {
    super();
    //Set default message
    this.state = {
      pokemon: [],
      bg: 'FEFEFE',
      txt: 'black',
    }
    this.dark = this.dark.bind(this);
    this.light = this.light.bind(this);
  }

  light() {
    this.setState(state => ({
      bg: 'FEFEFE',
      txt: 'black'
    }));
  }

  dark() {
    this.setState(state => ({
      bg: '1E1E1E',
      txt: 'white'
    }));
  }

  render(){ 
  return (
    <div class="meny">
        <Helmet>
        <style>{'body { background-color: #'+this.state.bg+';} *{color: '+this.state.txt+'}'}</style>
        </Helmet>
            <div class="light-dark-div"> 
            <button class="light-dark-btn" onClick={this.light}>LIGHT</button> 
            <button class="light-dark-btn" onClick={this.dark}>DARK</button>
            </div>
            <div>
            <ul class="meny-ul font">
            <Link to="/"><li class="meny-li">HOME</li></Link>
            <Link to="/Projects"><li class="meny-li">PROJECTS</li></Link>
            <Link to="/Photography"> <li class="meny-li">PHOTOGRAPHY</li></Link>
            <Link to="/Labs"> <li class="meny-li">LABS</li></Link>
            </ul>
            </div>
        </div>
  );
}
}

export default Navbar;
